<script setup lang="ts">
import { WToaster } from '@wiosna-dev/wiosna-ui'
</script>

<template>
  <WToaster />
</template>
